export const SET_TREE_SELECTION = 'SET_TREE_SELECTION';
export const setTreeSelection = (selection) => ({
    type: SET_TREE_SELECTION,
    payload: selection,
});

export const REMOVE_TREE_SELECTION = 'REMOVE_TREE_SELECTION';
export const removeTreeSelection = () => ({
    type: REMOVE_TREE_SELECTION,
});
